export default "__VITE_ASSET__V57Q42SU__"